import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material';

interface RevokeInviteConfirmDialogProps {
  open: boolean;
  email: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

export const RevokeInviteConfirmDialog: React.FC<
  RevokeInviteConfirmDialogProps
> = ({ open, email, onConfirm, onCancel, isLoading }) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="revoke-invite-dialog-title"
      aria-describedby="revoke-invite-dialog-description"
    >
      <DialogTitle id="revoke-invite-dialog-title">
        Revoke Invitation
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="revoke-invite-dialog-description">
          Are you sure you want to revoke the invitation for{' '}
          <strong>{email}</strong>? This action cannot be undone and the
          invitation link will no longer work.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={isLoading}
          data-testid="confirm-revoke-button"
        >
          {isLoading ? (
            <>
              <CircularProgress size={16} sx={{ mr: 1 }} />
              Revoking...
            </>
          ) : (
            'Revoke'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
